import { createFileRoute } from '@tanstack/react-router'
import { ChatPage } from '@/features/chat/ui/chat-page'
import { PageLayout } from '@/components/page-layout'

export const Route = createFileRoute('/_authenticated/chat/$topic-id')({
	component: ChatTopicRoute,
})

function ChatTopicRoute() {
	const params = Route.useParams()
	return (
		<PageLayout data-id='chat-page'>
			<ChatPage initialTopicId={params['topic-id']} />
		</PageLayout>
	)
}
